import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { InitService } from '../services/init.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const initService = inject(InitService);
  
  // Only add headers to API requests (not for assets, etc.)
  if (req.url.includes('/api/')) {
    let tenantId: string;
    
    // Get tenantId from tenant configuration with fallback
    if (initService.tenantConfig && initService.tenantConfig.tenantId) {
      tenantId = initService.tenantConfig.tenantId.toString();
      console.log('🏢 Adding TenantId from config:', tenantId);
    } else {
      // Fallback to default tenantId
      tenantId = '1';
      console.warn('⚠️ Tenant config not available, using fallback TenantId:', tenantId);
    }

    // Clone the request and add both TenantId and AppId headers
    const tenantReq = req.clone({
      setHeaders: {
        'TenantId': tenantId,
      }
    });

    return next(tenantReq);
  }

  // For non-API requests, proceed without modification
  return next(req);
};